var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app splash-container"},[_c('button',{staticClass:"nav-button selectedButton",on:{"click":_vm.patientRecall}},[_vm._v("Patient Recall")]),_c('div',{staticClass:"lineVertical"}),_c('button',{staticClass:"nav-button selectedButton",on:{"click":_vm.newSession}},[_vm._v("Start New Session")])])
}
var staticRenderFns = []

export { render, staticRenderFns }